import React, { useState } from "react";
import KickImage from 'Reuseables/KickImage';
import { withRouter } from "react-router-dom"
import moment from "moment"
import Countdown from "react-countdown";
import { Button, Collapse } from "reactstrap"
import { toast } from 'react-toastify';

/* COMPONENTS */
import OrderDetails from "./OrderDetails"

/* ASSETS */
import CopyIcon from "../../../../images/copyIcon.png"
import ArrowDown from '../../../../images/arrowDown.png';

/* UTILS */
import { ASSET_IMAGE } from "../../../../config"
import { convertToRupiah, formatCurrency } from "../../../../utils";

const renderer = ({ days, hours, minutes, seconds, completed, ...props }) => {
  const newHours = days * 24 + hours;
  return (
    <p>
      {newHours === 0 ? "00" : newHours}:{minutes === 0 ? " 00 " : minutes}:{seconds === 0 ? " 00" : seconds}
    </p>
  );
};

const isSnapSupported = () => {
  const snap = 'snap' in window;
  return snap !== undefined;
}

const PendingResult = ({
  userCurrency,
  invoice_number,
  status,
  expired,
  header_text,
  status_icon,
  expiry,
  payment_logo,
  handleExpire,
  payment_method_text,
  va_number,
  amount_to_be_paid,
  buttonText,
  invoice_url,
  onSuccess,
  onPending,
  onError,
  onClose,
  snapToken,
  id,
  disabled,
  isMitrans,
  isBankTransfer,
  customOnClick,
  banks,
  history,
  orderDetailsData
}) => {
  const [copiedText, setCopiedText] = useState(true)

  /* METHODS */
  const handleOpenSnap = () => {
    try {
      if (isSnapSupported()) {
        window.snap.pay(snapToken, {
          onSuccess: (r) => onSuccess(r),
          onPending: (r) => onPending(r),
          onError: (e) => onError(e),
          onClose: onClose,
          language: 'en'
        })
      }
      else {
        window.location = invoice_url;
      }
    } catch (error) {
      window.location = invoice_url;
    }
  }

  const handleOnClick = (e) => {
    e.preventDefault();
    customOnClick ? customOnClick() : handleOpenSnap();
  }

  const handeCopy = (value) => {
    if (!copiedText) return
    setCopiedText(false)
    navigator.clipboard.writeText(value)
    toast.success(
      'Copied',
      {
        position: 'top-right',
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
      },
    );
  }

  const handleGoToBuyingDashboard = (value) => {
    const params = {
      pathname: '/user_dashboard/order',
      state: { tabs: value }
    }
    history.push(params)
  }

  const [isOpenCollapse, setIsOpenCollapse] = useState(false)

  const {
    payment,
    product,
    addonProduct,
    sell,
    payment: { payment_method_request }
  } = orderDetailsData
  const isDebitCard = payment_method_request.includes('debit');

  return (
    <div className="pending-payment-wrapper">
      <div className="line">
        <p>Thank you, we have received your order</p>
        {
          window.innerWidth <= 768 ?
            <div className="collapse-order-id">
              <p>
                ORD ID <u onClick={() => handleGoToBuyingDashboard("Pending")}>{invoice_number}</u>
              </p>
              <KickImage onClick={() => setIsOpenCollapse(!isOpenCollapse)} src={ArrowDown} alt="..."/>
            </div>
            :
            <p>
              ORD ID <u onClick={() => handleGoToBuyingDashboard("Pending")}>{invoice_number}</u>
            </p>
        }
        {window.innerWidth <= 768 &&
          <Collapse isOpen={isOpenCollapse}>
            <OrderDetails
              payment={payment}
              product={product}
              addonProduct={addonProduct}
              sell={sell}
            />
          </Collapse>
        }
      </div>
      <div className="line">
        <p>{header_text}</p>
        <div className="clock-icon-wrapper">
          <KickImage src={status_icon} alt="..." />
        </div>
        {
          status === "PENDING" || status === "VERIFYING_BID" ?
            <Countdown
              date={moment(expiry).format()}
              renderer={renderer}
              daysInHours={true}
              zeroPadTime={2}
              onComplete={handleExpire}
            />
            : <p>00 : 00 : 00</p>
        }
        <p>Please complete your payment before</p>
        <p>{moment(expiry).format("dddd, LL HH:mm")}</p>
      </div>
      <div className="line">
        {
          isBankTransfer ?
            banks.map((bank, index) => {
              return (
                <div key={index} className="payment-method-wrapper bank-transfer-card">
                  {bank.bank_name !== "MIDTRANS" && <div className="payment-logo">
                    <KickImage src={`${ASSET_IMAGE}/email/${bank.bank_name.toLowerCase()}.png`} />
                  </div>}
                  <div className="payment-text-wrapper">
                    <p>Payment Method - {bank.bank_name}</p>
                    <div className="va-num-wrapper"
                      onClick={() => { handeCopy(bank.account_number) }}
                    >
                      <p>{bank.account_number}</p>
                      <KickImage src={CopyIcon} alt=".." />
                    </div>
                  </div>
                </div>
              )
            })
            : (
              <div className="payment-method-wrapper">
                <div className="payment-logo">
                  <KickImage src={payment_logo} />
                </div>
                <div className="payment-text-wrapper"
                  onClick={() => { va_number && handeCopy(va_number) }}
                >
                  <p>Payment Method - {isDebitCard? 'Debit Card' : payment_method_text}</p>
                  {va_number && <div className="va-num-wrapper">
                    <p>{va_number}</p>
                    <KickImage src={CopyIcon} alt=".." />
                  </div>}
                </div>
              </div>)
        }
        <div className="copy-amount-wrapper">
          <div className="copy-text-wrapper">
            <p>Amount to be paid</p>
            <p>
              {userCurrency && userCurrency.currency && userCurrency.ratio ?
              <>
                {formatCurrency(parseInt(amount_to_be_paid), userCurrency.ratio, userCurrency.currency)}
              </>
              :
              <>
                IDR.{" "}
                {convertToRupiah(parseInt(amount_to_be_paid))}
              </>
              }
            </p>
          </div>
        </div>
      </div>
      <div className="line">
        <p>If you have any questions about your order, please contact our team by email to <a href="mailto:info@kickavenue.com" title="Mail to info@kickavenue.com">info@kickavenue.com</a>. Please put your invoice number into your subject email.</p>
      </div>
      <div className="line">
        <Button
          className="see-instruction-btn"
          invoice_url
          onClick={handleOnClick}
          id={id}
          disabled={isMitrans ? (disabled || snapToken === null) : false}
          href={invoice_url}
        >
          <p>{buttonText.toLowerCase()}</p>
        </Button>
        <Button className="go-to-buying-btn"
          onClick={() => handleGoToBuyingDashboard("Pending")}
        >
          <p>Go To Buying Dashboard</p>
        </Button>
      </div>
    </div>
  )
}

export default withRouter(PendingResult)